const ProfileDashboard = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 text-white">
      <h2 className="text-3xl font-bold mb-4">Your Profile</h2>
      <p>Welcome back, PlayerOne!</p>
      <p>More features coming soon: watchlist, preferences, and more.</p>
    </div>
  );
};

export default ProfileDashboard;
